import React from "react";

import { Field, FieldDescription, FieldGroup, FieldLabel } from "@/components/ui/field";
import type { ReportStrategyPineRequirementsResponse } from "../../types/reportStrategyPine";
import { mergeComposeModesForHelp } from "../../utils/pineIrUi";
import { PineParseStageCapabilityMatrix } from "./PineParseStageCapabilityMatrix";
import {
  STRATEGY_PINE_SECTION_DESC_CLASS,
  STRATEGY_PINE_SECTION_LABEL_CLASS,
} from "./StrategyPineSectionCard";

export type PineRequirementsContentProps = {
  data: ReportStrategyPineRequirementsResponse | null;
};

export function PineRequirementsContent({
  data,
}: PineRequirementsContentProps): React.ReactElement {
  const composeModes = mergeComposeModesForHelp(data?.compose_modes);

  return (
    <FieldGroup data-strategy-pine-requirements-content="" className="min-w-0 gap-4">
      <PineParseStageCapabilityMatrix />

      <Field data-strategy-pine-compose-modes-help="" className="gap-3">
        <FieldLabel className={STRATEGY_PINE_SECTION_LABEL_CLASS}>Compose modes</FieldLabel>
        <div className="flex flex-col gap-3">
          {composeModes.map((mode) => (
            <Field key={mode.id} className="gap-1.5 border-l-2 border-border pl-3">
              <FieldLabel className={`${STRATEGY_PINE_SECTION_LABEL_CLASS} text-sm`}>
                {mode.label}
              </FieldLabel>
              <FieldDescription className={STRATEGY_PINE_SECTION_DESC_CLASS}>
                {mode.description}
              </FieldDescription>
            </Field>
          ))}
        </div>
      </Field>
    </FieldGroup>
  );
}
